import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import './appraisal-promotions-how-it-works.scss';

const CARDS_DATA = [
  {
    id: 1,
    header: '01',
    subheader: 'VIN or License Plate',
    text: 'Just answer some questions about your car. It could take less than 2 minutes.',
  },
  {
    id: 2,
    header: '02',
    subheader: 'See your cash offer',
    text: 'Review your Edmunds appraisal — it comes with a no-obligation offer from a dealer.',
  },
  {
    id: 3,
    header: '03',
    subheader: 'Get paid',
    text: "Like the dealer's offer? Bring in your car to get paid.",
  },
];

const HowItWorksCard = ({ header, subheader, text }) => (
  <div className="how-it-works-card p-1_25 h-100">
    <div className="header fw-bold d-inline-block">{header}</div>
    <hr className="my-1 w-100" />
    <div className="size-20 fw-bold text-cool-gray-30 mb-0_25">{subheader}</div>
    <div className="size-16 text-cool-gray-30 mb-1">{text}</div>
  </div>
);

HowItWorksCard.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subheader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  text: PropTypes.string.isRequired,
};

export const AppraisalPromotionsHowItWorks = () => (
  <div className="appraisal-promotions-how-it-works">
    <h2 className="main-header size-36 fw-medium text-cool-gray-10 text-center mb-1_5 mb-md-2">How it works</h2>
    <Row>
      {CARDS_DATA.map(({ id, header, subheader, text }) => (
        <Col key={id} xs={12} md={4} className="mb-1 mb-md-0">
          <HowItWorksCard header={header} subheader={subheader} text={text} />
        </Col>
      ))}
    </Row>
  </div>
);
